export default __webpack_public_path__ + "static/media/thumbnail.6618e20a.png";